/**
 * 管理者WEB課題 97
 * 追加仕様: Silmee/WalkXのいずれも、登録がない場合やデータなしで「異常なし」と表示されてしまう問題の解決
 * 修正方法: サーバから返却される各デバイスのステータスをDEVICE_STATUSの配列で制御する形に変更
 * 修正日付: 2022/11/02
 */
export const DEVICE_STATUS = [
  "異常なし",
  "登録なし",
  "データがありません",
  "3日以上装着なし",
];
